<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.9004 1.21973C16.6334 1.21973 21.2812 5.86755 21.2812 11.6006V21.6016C21.2811 22.695 20.3942 23.5811 19.3008 23.5811H5.7002C4.60675 23.5811 3.71992 22.695 3.71973 21.6016V3.2002C3.71973 2.10663 4.60663 1.21973 5.7002 1.21973H10.9004ZM5.7002 2.78027C5.46819 2.78027 5.28027 2.9682 5.28027 3.2002V21.6016C5.28047 21.8334 5.46832 22.0215 5.7002 22.0215H19.3008C19.5327 22.0215 19.7205 21.8334 19.7207 21.6016V12.001L19.7061 11.7119C19.5615 10.29 18.3605 9.18066 16.9004 9.18066H15.3008C14.2072 9.18066 13.3203 8.29376 13.3203 7.2002V5.60059C13.3203 4.1405 12.211 2.93952 10.7891 2.79492L10.5 2.78027H5.7002ZM16.5801 18.0254C16.9735 18.0652 17.2801 18.3969 17.2803 18.8008C17.2803 19.2048 16.9736 19.5374 16.5801 19.5771L16.501 19.5811H8.5C8.06933 19.5809 7.7207 19.2315 7.7207 18.8008C7.72083 18.3702 8.06941 18.0216 8.5 18.0215H16.501L16.5801 18.0254ZM16.5801 14.8252C16.9735 14.865 17.2801 15.1967 17.2803 15.6006C17.2803 16.0046 16.9736 16.3372 16.5801 16.377L16.501 16.3809H8.5C8.06933 16.3807 7.7207 16.0313 7.7207 15.6006C7.72083 15.17 8.06941 14.8214 8.5 14.8213H16.501L16.5801 14.8252ZM10.7646 9.75684C10.9822 9.19604 11.594 8.89521 12.1709 9.06543C12.7477 9.23573 13.0973 9.82018 12.9756 10.4092C12.8855 10.8645 12.6652 11.2996 12.3037 11.7148C11.9456 12.1262 11.448 12.5179 10.7998 12.8906C10.778 12.9032 10.7511 12.9035 10.7295 12.8906C10.0816 12.5181 9.58451 12.1259 9.22656 11.7148C8.86499 11.2996 8.64396 10.8645 8.55371 10.4092C8.55371 10.4079 8.55393 10.4065 8.55371 10.4053C8.43417 9.81657 8.7849 9.23447 9.36133 9.06543C9.9378 8.89645 10.5474 9.19678 10.7646 9.75684ZM14.3271 3.4707C14.6788 4.10128 14.8809 4.82732 14.8809 5.60059V7.2002C14.8809 7.4322 15.0688 7.62012 15.3008 7.62012H16.9004C17.6732 7.62012 18.399 7.8216 19.0293 8.17285C18.1363 6.05765 16.4425 4.36342 14.3271 3.4707Z"
				:fill="color"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgForYou',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
		isActive: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
